module.exports = __webpack_public_path__ + "static/img/user.1e4d80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 1